import React, { useContext, useEffect, useState } from "react";
import {
  getCampaigns,
  sendNotifications,
} from "../../apiClient/operations/paymentCollectionManagerOperations";
import usePagination from "../../tailwindUI/usePagination";
import { AlertContext } from "../../context/AlertContext";
import useFormatDate from "../useFormatDate";
import CircleIconCredentianls from "../CircleIconCredentials";

const LIMIT = 10;

export function useCampaigns({ filterString, sortString }) {
  const [campaignsData, setCampaignsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { setAlert } = useContext(AlertContext);
  const { formatDate } = useFormatDate();
  const paginate = usePagination();
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");

  const getCampaignsData = async () => {
    try {
      setIsLoading(true);
      const res = await getCampaigns({
        search: search,
        page: currentPage,
        limit: LIMIT,
        filters: filterString,
        sort: sortString,
      });
      setCampaignsData(transformData(res?.data));
      setPagination(
        paginate(res.total_pages, LIMIT, Math.ceil(res.total_items / LIMIT))
      );
    } catch (error) {
      setAlert({
        active: true,
        type: "error",
        message: error?.message || "Error al procesar tu solicitud",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const transformData = (campaigns) => {
    if (!campaigns) return [];
    return campaigns.map((campaign) => ({
      ...campaign,
      created: formatDate(campaign.created, "DD MMMM YYYY"),
      notifications_status: (
        <CircleIconCredentianls
          item={[
            {
              name: "notifications_status",
              status: campaign?.notifications_status,
            },
          ]}
          name="notifications_status"
        />
      ),
      payment_links_status: (
        <CircleIconCredentianls
          item={[
            {
              name: "payment_links_status",
              status: campaign?.payment_links_status,
            },
          ]}
          name="payment_links_status"
        />
      ),
      status: (
        <CircleIconCredentianls
          item={[
            {
              name: "status",
              status: campaign?.status,
            },
          ]}
          name="status"
        />
      ),
    }));
  };

  const sendManualNotifications = async () => {
    try {
      setIsLoading(true);
      const res = await sendNotifications();
      if (res?.data) {
        getCampaignsData();
      }
      setAlert({
        active: true,
        type: "success",
        message: res?.message || "Las notificaciones se enviaron correctamente",
      });
    } catch (error) {
      console.log(error);
      setAlert({
        active: true,
        type: "error",
        message: error?.message || "Error al procesar tu solicitud",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCampaignsData();
  }, [currentPage]);

  useEffect(() => {
    if (currentPage !== 1) setCurrentPage(1);
    getCampaignsData();
  }, [search, filterString, sortString]);

  return {
    campaignsData,
    sendManualNotifications,
    isLoading,
    pagination,
    currentPage,
    setCurrentPage,
    search,
    setSearch,
  };
}
